import { campaignAPI, merchantApi } from "@api";
import { ArrowLeftColor, ComponentMenuBar } from "@components";
import { _10MB, enumLanguage } from "@configs";
import { selectMerchant, setLoading } from "@redux";
import { formatMessage, useNotify } from "@utils";
import { Button, Select, Skeleton } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import LoadingOverlay from "react-loading-overlay-ts";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { ExampleUploadActivity } from "src/Components/UploadActivity/ExampleActivityUpload/ExampleActivityUpload";
import { SuccessActivityModal } from "src/Components/UploadActivity/SuccessActivityModal/SuccessActivityModal";
import { UploadImageBox } from "src/Components/UploadActivity/UploadImageBox/UploadImageBox";
import { StyledActivityPage } from "./UploadActivityStyled";

const tkey = "page.uploadActivity.";
//@ts-ignore
export const PageUploadActivity = () => {
    // Hook
    const history = useHistory();
    const dispatch = useDispatch();
    // Redux
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);
    // Notify
    const { error } = useNotify();
    // Translation
    const { t } = useTranslation();
    // Image
    const [activityImg, setActivityImg] = useState<string>("");
    const [imgFile, setImgFile] = useState<any>("");
    const [showImg, setShowImg] = useState<boolean>(false);
    const [showDone, setShowDone] = useState<boolean>(false);
    const [isLoading, setIsloading] = useState(true);
    const [activityType, setActivityType] = useState<string>("");
    const [campaign, setCampaign] = useState<any>();
    const { id } = useParams<{ id: string }>();
    const [isLoaderActive, setIsLoaderActive] = useState<boolean>(false);
    const i18nextLng = window.localStorage.i18nextLng;

    // GET Campaign
    const getCampaign = async () => {
        setIsloading(true);
        try {
            const get = await campaignAPI.getCampaign(id);
            if (get.data) {
                setCampaign(get.data);
                setIsloading(false);
            }
        } catch (err: any) {
            console.log(err);
            setIsloading(false);
        }
    };

    // On change selected image
    const onChangeImg = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!e.target.files || e.target.files.length === 0) {
            setActivityImg("");
            return;
        } else {
            const objectUrl = URL.createObjectURL(e.target.files[0]);
            setImgFile(e.target.files[0]);
            setActivityImg(objectUrl);
        }
    };

    const onChangeActivityType = (value: string) => {
        setActivityType(value);
    };

    const uploadImage = async (formData: FormData) => {
        try {
            const res = await merchantApi.uploadImage(formData);
            return res.data.publicUrl;
        } catch (err: any) {
            error(formatMessage(err.response));
        } finally {
            dispatch(setLoading(false));
        }
    };

    const handleConfirm = async () => {
        await null;
        try {
            dispatch(setLoading(true));
            setIsLoaderActive(true);
            if (activityImg !== "") {
                if (imgFile.size >= _10MB) {
                    error(t("validation.image.max_size"));
                    dispatch(setLoading(false));
                    setIsLoaderActive(true);
                } else {
                    if (activityType === "") {
                        error(t(tkey + "error.selectActivity"));
                    } else {
                        const formData = new FormData();
                        formData.append("file", imgFile);

                        let imgUrl = await uploadImage(formData);
                        if (imgUrl) {
                            let payload: any = {
                                imageUrl: imgUrl,
                                activityType: activityType,
                            };
                            await campaignAPI.uploadCampaign(id, payload);
                            setIsLoaderActive(false);
                            setShowDone(true);
                        }
                    }
                }
            } else {
                error(t(tkey + "error.emptyError"));
            }
        } catch (err: any) {
            error(formatMessage(err.response));
            console.log("err", err);
        } finally {
            dispatch(setLoading(false));
            setIsLoaderActive(false);
        }
    };

    useEffect(() => {
        getCampaign();
    }, []);

    // Prevent page from no merchant
    useEffect(() => {
        if (!merchant) {
            setIsloading(true);
        }
    });

    return (
        <LoadingOverlay active={isLoaderActive} spinner text="Loading...">
            <StyledActivityPage
                themeColor={themes?.themeColor!}
                campaignColor={campaign?.campaignColor}
            >
                <>
                    <header>
                        <div className="back-arrow">
                            <ArrowLeftColor
                                color={themes?.themeColor ?? "#fff"}
                                onClick={() => history.goBack()}
                            />
                        </div>
                    </header>
                    <div className="step-logo">
                        <Skeleton loading={isLoading} active avatar title={false} paragraph={false}>
                            <div className="logo">
                                {/* <img
                                    src={merchant?.themes?.logoSmallUrl || "../../images/logo-suntory.png"}
                                    alt=""
                                /> */}
                                <img
                                    src={
                                        campaign?.campaignLogo ||
                                        "../../images/logo-club-wellness.svg"
                                    }
                                    alt=""
                                />
                            </div>
                        </Skeleton>
                    </div>
                    <div className="title-receipt">
                        <Skeleton
                            loading={isLoading}
                            active
                            title={{ width: 168 }}
                            paragraph={{ rows: 2, width: [268, 206] }}
                        >
                            <h1>
                                {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                                    ? campaign?.action?.title?.EN
                                    : campaign?.action?.title?.TH}
                            </h1>
                            <p>
                                {i18nextLng === enumLanguage.EN || i18nextLng === enumLanguage.EN_GB
                                    ? campaign?.action?.description?.EN
                                    : campaign?.action?.description?.TH}
                            </p>
                        </Skeleton>
                    </div>
                </>
                <div className="select-type">
                    <Skeleton
                        loading={isLoading}
                        active
                        title={true}
                        paragraph={{ rows: 1, width: [100] }}
                    >
                        <div className="title-select-type">
                            {t("page.uploadActivity.selectTypeLabel")}
                        </div>
                        <Select
                            defaultValue={t("page.uploadActivity.selectActivityPlaceholder")}
                            onChange={onChangeActivityType}
                        >
                            {campaign?.action?.activityType?.map((item: any, inx: any) => {
                                return (
                                    <Select.Option key={inx} value={item}>
                                        {item}
                                    </Select.Option>
                                );
                            })}
                        </Select>
                    </Skeleton>
                </div>
                <div className="layout-img-skeleton">
                    <UploadImageBox
                        handleChangeImage={onChangeImg}
                        isLoading={isLoading}
                        image={activityImg}
                        color={campaign?.campaignColor}
                    />
                    <div className="btn-skeleton">
                        <Skeleton loading={isLoading} active title={false} paragraph={{ rows: 2 }}>
                            <Button className="view-btn-type-2" onClick={() => setShowImg(true)}>
                                {t("page.uploadActivity.viewExampleBtn")}
                            </Button>
                            <div className="btn-section">
                                <Button className="btn confirm" onClick={handleConfirm}>
                                    {t("page.uploadActivity.sendActivityBtn")}
                                    <span>
                                        <img src="../../images/ic-send.png" alt="" />
                                    </span>
                                </Button>
                            </div>
                        </Skeleton>
                    </div>
                    {showImg ? (
                        <ExampleUploadActivity
                            campaign={campaign}
                            handleClose={() => setShowImg(false)}
                        />
                    ) : null}
                    {showDone ? (
                        <SuccessActivityModal
                            handleClose={() => {
                                setShowDone(false);
                                history.goBack();
                            }}
                        />
                    ) : null}
                </div>
                <ComponentMenuBar />
            </StyledActivityPage>
        </LoadingOverlay>
    );
};
